import { Input } from '@/shared/ui/input';
import { Search } from 'lucide-react';

interface WorkOrdersSearchProps {
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
}

export function WorkOrdersSearch({ searchTerm, onSearchTermChange }: WorkOrdersSearchProps) {
  return (
    <div className="relative ml-[5px]">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
      <Input
        type="text"
        placeholder="Search jobs..."
        value={searchTerm}
        onChange={(e) => onSearchTermChange(e.target.value)}
        className="pl-9 w-[280px] h-9"
      />
    </div>
  );
}
